import Vue from 'vue'
import Router from 'vue-router'

import Home from '@/components/Home'
import Main from '@/components/Main'

import Unbind from '@/components/unbind'
import Login from '@/components/user/login'
import Forget from '@/components/user/forget'
import Register from '@/components/user/register'
import Agreement from '@/components/user/agreement'
import Certification from '@/components/user/certification'
import Safety from '@/components/user/safety'
import Menu from '@/components/product/menu'
import Console from '@/components/console/index'
import Vps from '@/components/product/vps'
import Vhost from '@/components/product/vhost'
import Freebeian2 from '@/components/user/freebeian'
import Freevhost2 from '@/components/user/freevhost'
import Freeserver2 from '@/components/user/freeserver'
import Domain from '@/components/product/domain'
import Beian from '@/components/product/beian'
import Buy from '@/components/product/buy'
import Finance from '@/components/finance/catalog'
import Money from '@/components/finance/money'
import Payment from '@/components/finance/payment'
import Cashcoupon from '@/components/finance/cashcoupon'
import Message from '@/components/console/message'
import Gongdan from '@/components/console/gongdan'
import Freebeian from '@/components/console/freebeian'
import Addfreebeian from '@/components/console/addfreebeian'
import Workorder from '@/components/console/workorder'
import Workoradd from '@/components/console/workoradd'
import Workorreply from '@/components/console/workorreply'
import Workorassess from '@/components/console/workorassess'
import Domainrenew from '@/components/console/domainrenew'
import Domainmanage from '@/components/console/domainmanage'
import Changedns from '@/components/console/changedns'
import Domainrecord from '@/components/console/domainrecord'
import Vhostrecord from '@/components/console/vhostrecord'
import Vpsrecord from '@/components/console/vpsrecord'
import Domainanaly from '@/components/console/domainanaly'
import Analyadd from '@/components/console/analyadd'
import Changeanaly from '@/components/console/changeanaly'
import Hostmanage from '@/components/console/hostmanage'
import Freevhost from '@/components/console/freevhost'
import Freevhostdelay from '@/components/console/freevhostdelay'
import Freevpsdelay from '@/components/console/freevpsdelay'
import Freeserver from '@/components/console/freeserver'
import Hostrenew from '@/components/console/hostrenew'
import Hostlevel from '@/components/console/hostlevel'
import Domainname from '@/components/console/hostoperate/domainname'
import Domainadd from '@/components/console/hostoperate/domainadd'
import Defaultset from '@/components/console/hostoperate/defaultset'
import Defaultsetadd from '@/components/console/hostoperate/defaultsetadd'
import Errorpage from '@/components/console/hostoperate/Errorpage'
import Scriptserror from '@/components/console/hostoperate/scriptserror'
import Redirecturl from '@/components/console/hostoperate/redirecturl'
import Phpselect from '@/components/console/hostoperate/phpselect'
import Netselect from '@/components/console/hostoperate/netselect'
import Preventchain from '@/components/console/hostoperate/preventchain'
import Clearnet from '@/components/console/hostoperate/clearnet'
import Gzip from '@/components/console/hostoperate/gzip'
import Actauth from '@/components/console/hostoperate/actauth'
import Dirauth from '@/components/console/hostoperate/dirauth'
import Blacklist from '@/components/console/hostoperate/blacklist'
import serverManage from '@/components/console/serverManage'
import Server from '@/components/console/server'
import Serverrenew from '@/components/console/serverrenew'
import Serverlevel from '@/components/console/serverlevel'
import Resetpassword from '@/components/console/serveroperate/resetpassword'
import Reinstallserver from '@/components/console/serveroperate/reinstallserver'
import Host from '@/components/console/host'
import domain from '@/components/console/domain'
import About from '@/components/user/about'
import Contact from '@/components/user/contact'
import Pay from '@/components/user/pay'
import Act from '@/components/user/act'

Vue.use(Router)

const router = new Router({
  routes: [
    {
      path: '/',
      redirect: "/home"
    },
    {
      path: '/home',
      name: 'Home',
      component: Home
    },
    {
      path: '/main',
      name: 'Main',
      component: Main
    },
    {
      path: '/about',
      name: 'About',
      component: About
    },
    {
      path: '/contact',
      name: 'Contact',
      component: Contact
    },
    {
      path: '/pay',
      name: 'Pay',
      component: Pay
    },
    {
      path: '/unbind',
      name: 'Unbind',
      component: Unbind
    },
    {
      path: '/product/:name',
      name: 'Menu',
      component: Menu
    },
    {
      path:'/console',
      name: 'Console',
      component: Console
    },
    {
      path: '/login',
      name:'Login',
      component: Login
    },
    {
      path: '/forget',
      name:'Forget',
      component: Forget
    },
    {
      path: '/register',
      name:'Register',
      component: Register
    },
    {
      path: '/agreement',
      name:'Agreement',
      component: Agreement
    },
    {
      path:'/safety',
      name: 'Safety',
      component: Safety
    },
    {
      path:'/vps',
      name: 'Vps',
      component: Vps
    },
    {
      path:'/vhost',
      name: 'Vhost',
      component: Vhost
    },
    {
      path:'/freebeian',
      name: 'Freebeian2',
      component: Freebeian2
    },
    {
      path:'/freevhost',
      name: 'Freevhost2',
      component: Freevhost2
    },
    {
      path:'/freeserver',
      name: 'Freeserver2',
      component: Freeserver2
    },
    {
      path:'/domain',
      name: 'Domain',
      component: Domain
    },
    {
      path:'/beian',
      name: 'Beian',
      component: Beian
    },
    {
      path:'/buy',
      name: 'Buy',
      component: Buy
    },
    {
      path:'/user/finance',
      name: 'Finance',
      component: Finance
    },
    {
      path:'/user/certification',
      name: 'Certification',
      component: Certification
    },
    {
      path:'/user/money',
      name: 'Money',
      component: Money
    },
    {
      path:'/user/payment',
      name: 'Payment',
      component: Payment
    },
    {
      path:'/user/cashcoupon',
      name: 'Cashcoupon',
      component: Cashcoupon
    },
    {
      path:'/user/message',
      name: 'Message',
      component: Message
    },
    {
      path:'/user/gongdan',
      name: 'Gongdan',
      component: Gongdan
    },
    {
      path:'/user/freebeian',
      name: 'Freebeian',
      component: Freebeian
    },
    {
      path:'/user/addfreebeian',
      name: 'Addfreebeian',
      component: Addfreebeian
    },
    {
      path:'/user/workorder/:id',
      name: 'Workorder',
      component: Workorder
    },
    {
      path:'/user/workoradd',
      name: 'Workoradd',
      component: Workoradd
    },
    {
      path:'/user/workorreply/:id',
      name: 'Workorreply',
      component: Workorreply
    },
    {
      path:'/user/workorassess/:id',
      name: 'Workorassess',
      component: Workorassess
    },
    {
      path:'/user/serverManage',
      name: 'serverManage',
      component: serverManage
    },
    {
      path:'/user/host',
      name: 'host',
      component: Host
    },
    {
      path:'/user/domain',
      name: 'domain',
      component: domain
    },
    {
      path:'/user/domainrenew/:id',
      name: 'Domainrenew',
      component: Domainrenew
    },
    {
      path:'/user/domainmanage/:id',
      name: 'Domainmanage',
      component: Domainmanage
    },
    {
      path:'/user/changedns/:id',
      name: 'Changedns',
      component: Changedns
    },
    {
      path:'/user/domainrecord/:name',
      name: 'Domainrecord',
      component: Domainrecord
    },
    {
      path:'/user/vhostrecord',
      name: 'Vhostrecord',
      component: Vhostrecord
    },
    {
      path:'/user/vpsrecord',
      name: 'Vpstrecord',
      component: Vpsrecord
    },
    {
      path:'/user/domainanaly/:name',
      name: 'Domainanaly',
      component: Domainanaly
    },
    {
      path:'/user/changeanaly/:name/:id',
      name: 'Changeanaly',
      component: Changeanaly
    },
    {
      path:'/user/analyadd/:name',
      name: 'Analyadd',
      component: Analyadd
    },
    {
      path:'/user/hostmanage/:id',
      name: 'Hostmanage',
      component: Hostmanage
    },
    {
      path:'/user/hostrenew/:id',
      name: 'Hostrenew',
      component: Hostrenew
    },
    {
      path:'/user/hostlevel/:id',
      name: 'Hostlevel',
      component: Hostlevel
    },
    {
      path:'/user/freevhost',
      name: 'Freevhost',
      component: Freevhost
    },
    {
      path:'/user/freeserver',
      name: 'Freeserver',
      component: Freeserver
    },
    {
      path:'/user/freevhostdelay',
      name: 'Freevhostdelay',
      component: Freevhostdelay
    },
    {
      path:'/user/freevpsdelay',
      name: 'Freevpsdelay',
      component: Freevpsdelay
    },
    {
      path:'/user/domainname/:id',
      name: 'Domainname',
      component: Domainname
    },
    {
      path:'/user/domainadd/:id',
      name: 'Domainadd',
      component: Domainadd
    },
    {
      path:'/user/defaultset/:id',
      name: 'Defaultset',
      component: Defaultset
    },
    {
      path:'/user/defaultsetadd/:id',
      name: 'Defaultsetadd',
      component: Defaultsetadd
    },
    {
      path:'/user/errorpage/:id',
      name: 'Errorpage',
      component: Errorpage
    },
    {
      path:'/user/scriptserror/:id',
      name: 'Scriptserror',
      component: Scriptserror
    },
    {
      path:'/user/redirecturl/:id',
      name: 'Redirecturl',
      component: Redirecturl
    },
    {
      path:'/user/phpselect/:id',
      name: 'Phpselect',
      component: Phpselect
    },
    {
      path:'/user/netselect/:id',
      name: 'Netselect',
      component: Netselect
    },
    {
      path:'/user/preventchain/:id',
      name: 'Preventchain',
      component: Preventchain
    },
    {
      path:'/user/gzip/:id',
      name: 'Gzip',
      component: Gzip
    },
    {
      path:'/user/clearnet/:id',
      name: 'Clearnet',
      component: Clearnet
    },
    {
      path:'/user/actauth/:id',
      name: 'Actauth',
      component: Actauth
    },
    {
      path:'/user/dirauth/:id',
      name: 'Dirauth',
      component: Dirauth
    },
    {
      path:'/user/blacklist/:id',
      name: 'Blacklist',
      component: Blacklist
    },
    {
      path:'/user/server/:id',
      name: 'Server',
      component: Server
    },
    {
      path:'/user/serverrenew/:id',
      name: 'Serverrenew',
      component: Serverrenew
    },
    {
      path:'/user/serverlevel/:id/:cpu/:ram/:ssd/:net',
      name: 'Serverlevel',
      component: Serverlevel
    },
    {
      path:'/user/resetpassword/:id/:name',
      name: 'Resetpassword',
      component: Resetpassword
    },
    {
      path:'/user/reinstallserver/:id',
      name: 'Reinstallserver',
      component: Reinstallserver
    },
    {
      path:'/user/act',
      name: 'Act',
      component: Act
    }
  ]
})

router.afterEach( ( to, from, next ) => {
  setTimeout(() => {
    let _hmt = _hmt || [];
    (() => {
      document.getElementById('baidu_tj') && document.getElementById('baidu_tj').remove();
      let hm = document.createElement('script');
      hm.src = 'https://s96.cnzz.com/z_stat.php?id=1275521789&web_id=1275521789';
      hm.id = 'baidu_tj';
      let s = document.getElementsByTagName('script')[0];
      s.parentNode.insertBefore(hm, s);
    })();
  }, 50);
} )

export default router



// WEBPACK FOOTER //
// ./src/router/index.js